import { useDrawingStore } from "@/stores/fileStore";
import { computed, onMounted, onUnmounted, ref } from "vue";
import {
  LOCAL_DRAWINGS_LIMIT,
  STORAGE_QUOTA_WARNING_PERCENT,
} from "@/utils/constants";
const percentageUsed = ref(0);

export const useGetStorageInfo = () => {
  const percentageLimitLevel = computed(() => {
    if (percentageUsed.value < STORAGE_QUOTA_WARNING_PERCENT * (2 / 3)) {
      return "low";
    }
    if (percentageUsed.value < STORAGE_QUOTA_WARNING_PERCENT) {
      return "medium";
    }
    return "high";
  });

  const drawingStore = useDrawingStore();

  const localDrawingsCount = computed(() => {
    return drawingStore.localDrawings?.length ?? 0;
  });

  // Aligned on LOCAL_DRAWINGS_LIMIT (the same limit StorageBanner warns about)
  // so "high" here and the banner threshold never disagree.
  const countLimitLevel = computed(() => {
    if (localDrawingsCount.value < LOCAL_DRAWINGS_LIMIT * 0.5) {
      return "low";
    }
    if (localDrawingsCount.value < LOCAL_DRAWINGS_LIMIT) {
      return "medium";
    }
    return "high";
  });

  const isHighStorageLimit = computed(
    () =>
      countLimitLevel.value === "high" || percentageLimitLevel.value === "high"
  );

  return {
    percentageUsed,
    percentageLimitLevel,
    localDrawingsCount,
    countLimitLevel,
    isHighStorageLimit,
  };
};

export const useStorageQuota = () => {
  let intervalId: any = null;
  const checkStorage = async () => {
    if (navigator.storage && navigator.storage.estimate) {
      const quota = await navigator.storage.estimate();
      if (!quota?.quota || !quota.usage) return;
      percentageUsed.value = (quota.usage / quota.quota) * 100;
    }
  };

  onMounted(() => {
    intervalId = setInterval(checkStorage, 2 * 1000);
    checkStorage();
  });

  onUnmounted(() => {
    if (intervalId) {
      clearInterval(intervalId);
    }
  });
};
